export default "__VITE_ASSET__DQGJzEh$__"